module.exports = __webpack_public_path__ + "img/26.f88ba8ec.jpg";